import Banner from '@atlaskit/banner';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { AlgoliaConfig } from '../../records/CommonConfig';

export default class SearchConfigValidation extends Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
    config: PropTypes.instanceOf(AlgoliaConfig),
  };

  render() {
    if (this.props.config) {
      return <div>{this.props.children()}</div>;
    } else {
      console.error('Search config is not provided');
      return (
        <Banner
          appearance="error"
          isOpen={true}
          icon={<WarningIcon label="Warning icon" secondaryColor="inherit" />}
        >
          Search is not configured
        </Banner>
      );
    }
  }
}
